import { ScrollToApplyButton } from '#/components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from '#/components/Breakpoint/DesktopOnly';
import { DropdownMenuItem } from '#/components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { SaveListingButton } from '#/components/SaveButton/SaveListingButton';
import { ShareListingButton } from '#/components/ShareListingButton/ShareListingButton';
import { ListingActionsDropdown } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingActionsDropdownMarkApplied } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdownMarkApplied';
import { ListingViewActionButtons } from '#/modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { ApiJob } from '#/modules/listing/jobs/api/types/ApiJob';
import type { OrgDashboardApiJob } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiJob';

type Props = {
  job: ApiJob | OrgDashboardApiJob;

  applied: boolean;
  onMarkAsApplied: () => Promise<void>;
  onMarkAsNotApplied: () => Promise<void>;

  // Save job
  jobSaved: boolean;
  onSaveJob: () => Promise<void>;
  onUnsaveJob: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewJobActionButtons({
  job,
  applied,
  onMarkAsApplied,
  onMarkAsNotApplied,
  jobSaved,
  onSaveJob,
  onUnsaveJob,
  orgSaved,
  shouldShowSaveOrgTooltip,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  return (
    <ListingViewActionButtons>
      <ScrollToApplyButton
        applied={job.hasAts && applied}
        eventName="Apply Button on Job Listing"
      />

      <SaveListingButton
        listingType={job.type}
        listingSaved={jobSaved}
        onSaveListing={onSaveJob}
        onUnsaveListing={onUnsaveJob}
        orgDetails={{
          shouldShowSaveOrgTooltip,
          onSaveOrg,
          onDismissSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!job.url}
          listingId={job.id}
          listingType={job.type}
          listingUrl={job.url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={job.id}
        listingType={job.type}
        listingUrl={job.url}
        orgDetails={
          job.org
            ? {
                orgId: job.org.id,
                orgName: job.org.name,
                orgType: job.org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={
          !job.hasAts && (
            <DropdownMenuItem>
              <ListingActionsDropdownMarkApplied
                applied={applied}
                onMarkAsApplied={onMarkAsApplied}
                onMarkAsNotApplied={onMarkAsNotApplied}
              />
            </DropdownMenuItem>
          )
        }
      />
    </ListingViewActionButtons>
  );
}
